module.exports = __webpack_public_path__ + "static/media/om.7171b1e2.svg";